import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { CloseModal, SuccessIcon } from "../../../assets/icons/ModalIcons";
import xss from "xss";

const CustomModal = ({
  isSuccess,
  closeSuccess,
  message,
  redirectUrl,
  redirectDelay = 3000,
}) => {
  const [countdown, setCountdown] = useState(Math.ceil(redirectDelay / 1000));

  useEffect(() => {
    if (isSuccess && redirectUrl) {
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            try {
              window.location.href = redirectUrl;
            } catch (error) {
              console.error("Failed to redirect:", error);
              closeSuccess();
            }
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isSuccess, redirectUrl, redirectDelay]);

  const handleClose = () => {
    if (redirectUrl) {
      try {
        window.location.href = redirectUrl;
      } catch (error) {
        console.error("Failed to redirect:", error);
        closeSuccess();
      }
    } else {
      closeSuccess();
    }
  };
  return (
    <>
      <Transition appear show={isSuccess} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => {}}
          preventOutsideClick
        >
          <div className="fixed inset-0 bg-black/25" aria-hidden="true" />
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full sm:max-w-lg max-w-xs transform overflow-hidden rounded-3.5xl bg-white sm:p-9 py-6 px-5 text-left align-middle shadow-xl transition-all">
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={handleClose}
                    className="cursor-pointer flex justify-end mb-2.5"
                  >
                    <CloseModal fillColor="fill-gray-2500" />
                  </span>
                  <div className="flex flex-col items-center justify-between gap-y-3">
                    <SuccessIcon />
                    <Dialog.Title
                      as="h3"
                      className="text-xl text-center strong-text-font sm:text-2xl tracking-tighter_1 text-purple-1100"
                      dangerouslySetInnerHTML={{
                        __html: xss(message),
                      }}
                    />
                    {redirectUrl && (
                      <div
                        className="text-sm text-center mt-4"
                        style={{ color: "#1D0642" }}
                      >
                        <div className="flex items-center justify-center gap-2 mb-2">
                          <svg
                            className="animate-spin h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            style={{ color: "#5E44FF" }}
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          <span
                            className="font-medium"
                            style={{ color: "#0F0624" }}
                          >
                            Redirecting in {countdown} seconds...
                          </span>
                        </div>
                        <div
                          className="w-full rounded-full h-2"
                          style={{ backgroundColor: "#F0F0F0" }}
                        >
                          <div
                            className="h-2 rounded-full transition-all duration-1000 ease-linear"
                            style={{
                              background:
                                "linear-gradient(to right, #5E44FF, #9C8CFF)",
                              width: `${((3 - countdown) / 3) * 100}%`,
                            }}
                          ></div>
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={handleClose}
                    className="bg-purple-1500 hover:bg-purple-400 font-semibold text-white py-2.5 px-7 tracking-tighter_1 sm:text-lg text-base shadow-lg rounded-full w-full mx-auto sm:mt-5 mt-3.5"
                  >
                    {redirectUrl ? "Go Now" : "Continue Browsing"}
                  </button>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default CustomModal;
